import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import { DashboardLoader } from "./utils/Loading";
  const Signout = () => {
    const { oktaAuth } = useOktaAuth();
    const location = useLocation();
    useEffect(async () => {
      if (location.pathname === "/signout") {
        await oktaAuth.signInWithRedirect();
      }
    }, [location]);  
    return <DashboardLoader />;
  };

  export default Signout;